import {Hal} from "./hal.model";
import {Page} from "../page.model";

export class PagedHal extends Hal {
    page: Page;

    constructor(data: any) {
        super(data);
        this.page = new Page(data.page);
    }
}
